__turbopack_context__.v({
  "expanderHeader": "Expander-module-scss-module__KF7Qsa__expanderHeader",
  "expanderWrapper": "Expander-module-scss-module__KF7Qsa__expanderWrapper",
});
